import { useMutation, useQueryClient } from "@tanstack/react-query"
import { syncFriendScenarios } from "../lib/sync-friend-scenarios"
import { scenarioKeys } from "../model/keys"
import type { ScenarioAcceptButton } from "../model/types"
import { acceptScenario, proposeScenario } from "./client"

export function useProposeScenario(userId: number, friendId: number) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (input: { scenario_id: number; answer: string }) =>
			proposeScenario(friendId, {
				user_id: userId,
				scenario_id: input.scenario_id,
				answer: input.answer,
			}),
		onSuccess: (scenarios) =>
			syncFriendScenarios(queryClient, userId, friendId, scenarios),
		// The scenario query lives with staleTime Infinity: without this the retry
		// after a rejected propose would resend the very same stale scenario_id.
		onSettled: () =>
			queryClient.invalidateQueries({
				queryKey: scenarioKeys.current(friendId),
			}),
	})
}

export function useAcceptScenario(userId: number, friendId: number) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (button: ScenarioAcceptButton) =>
			acceptScenario(friendId, { user_id: userId, button }),
		onSuccess: (scenarios) =>
			syncFriendScenarios(queryClient, userId, friendId, scenarios),
		onSettled: () =>
			queryClient.invalidateQueries({
				queryKey: scenarioKeys.current(friendId),
			}),
	})
}
